import { render, staticRenderFns } from "./Responsible.vue?vue&type=template&id=eb7fb0aa&scoped=true&"
import script from "./Responsible.vue?vue&type=script&lang=js&"
export * from "./Responsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7fb0aa",
  null
  
)

export default component.exports